import { useEntity } from '@backstage/plugin-catalog-react';
import { InfoCard, Link } from '@backstage/core-components';
import {
  getDeploySourceFromEntity,
  getAppSourceFromEntity,
  SourceLink,
} from './deploySourceUtils';

const Row = ({ label, link }: { label: string; link: SourceLink }) => (
  <div style={{ marginBottom: 8 }}>
    <div style={{ fontWeight: 500 }}>{label}</div>
    <Link to={link.url}>{link.label}</Link>
  </div>
);

export const EntityDeploySourceCard = () => {
  const { entity } = useEntity();
  const deploySource = getDeploySourceFromEntity(entity);
  const appSource = getAppSourceFromEntity(entity);
  if (!deploySource && !appSource) return null;
  return (
    <InfoCard title="Deploy Source">
      {deploySource && <Row label="Deploy source" link={deploySource} />}
      {appSource && <Row label="App source" link={appSource} />}
    </InfoCard>
  );
};
